//TODO: Violation this does not belong within this package!

import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AgentDto} from "../../../../../../am/model/dto/entity/agent.dto";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestComplex} from "../../../../../../../core/shared/dto/object/request/object-request-complex";
import {
    ObjectRequestComplexNode
} from "../../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../../../core/shared/dto/object/request/object-request-relation";
import {DtoList} from "../../../../../../../core/shared/dto/dto.list";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../core/shared/helper/widget-function-call-back-create";
import {CallRecipientTypeEnum} from "../../../../../../../feature-crm/pc/enum/call-recipient-type-enum.enum";
import {Sorting} from "../../../../../../../core/shared/misc/sorting";
import {ObjectChangeInformation} from "../../../../../../../core/shared/logic/object-change-information";
import {QlQueryDto} from "../../../../../../../core/shared/ql/data/dto/ql-query.dto";
import {MsCalendarEventDto} from "../../../../../../am/model/dto/api/ms/ms-calendar.types";

/**
 * Used
 */

type TabViewType = 'call' | 'address' | 'appointment';

@Component({
    selector: 'tm-ticket-customer-contact',
    templateUrl: 'tm-ticket-customer-contact.component.html',
    standalone: false,
})
export class TmTicketCustomerContactComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    hideSelectionHeader: boolean = true;

    @Input() appointmentTypeId: number;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() ticketActionIdentifier: ObjectIdentifier;

    @Output() onAppointmentCreate: EventEmitter<MsCalendarEventDto> = new EventEmitter();

    objectCallsWidget: WidgetData;
    addressWidget: WidgetData;
    addressObjectWidget: WidgetData;

    agents: AgentDto[];

    addressId: number;
    addressName: string;
    createAddress: boolean;

    name: string;
    addresses: any[];
    selectAddress: number;

    currentView: TabViewType = 'call';
    activeIndex: TabViewType = 'call';

    tabs: { key: TabViewType, label: string }[];


    constructor(
        protected coreService: MvsCoreService) {

    }

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.handleTabAssignment();
        this.refreshAddressObjectWidget();
        this.showCustomerCallWidget();
        this.refreshComponent();

    }

    handleTabAssignment() {

        if (this.objectIdentifier.objectType == 'cr.Customer') {
            this.tabs = [
                {key: 'call', label: 'Call Info'},
                {key: 'address', label: 'Confirm Address'},
                {key: 'appointment', label: 'Book Appointment'}
            ];
        }

        if (this.objectIdentifier.objectType == 'lm.LmLead') {
            this.tabs = [
                {key: 'call', label: 'Call Info'},
                {key: 'appointment', label: 'Book Appointment'}
            ];
        }

    }


    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    fetchAppointmentTypeAgents() {
        const filterCriteria = FilterCriteria.create('appointmentType', FilterCriteria.cOperatorEqual, this.appointmentTypeId);
        const objectRequest = ObjectRequestList.createBasic(false, [filterCriteria], []);

        objectRequest.objectRequestComplex = ObjectRequestComplex.build(true, false,
            ObjectRequestComplexNode.createSimpleAttributeNode('agent')
        );

        this.coreService.getCrudService('as.AppointmentTypeAgent').list(objectRequest).subscribe(res => {
            this.agents = res.entries.map(agentInfo => agentInfo.agentDto);
        });
    }


    getMainAddress() {
        // Determine dynamic mappings based on object type
        const objectType = this.objectIdentifier?.objectType;

        let mainRelationName = '';
        let addressRelationNode = '';
        let addressEntity = '';
        let addressWidgetKey = '';
        let addressWidgetTitle = '';

        switch (objectType) {
            case 'cr.Customer':
                mainRelationName = 'customerAddress';
                addressRelationNode = 'cr.CustomerAddress#customer';
                addressEntity = 'cr.CustomerAddress';
                addressWidgetKey = 'tm.ticket.cr.customer.address.widget.list';
                addressWidgetTitle = 'Customer Address';
                break;

            case 'lm.LmLead':
                mainRelationName = 'leadAddress';
                addressRelationNode = 'lm.LmLeadAddress#lead';
                addressEntity = 'lm.LmLeadAddress';
                addressWidgetKey = 'tm.ticket.lm.lead.address.widget.list';
                addressWidgetTitle = 'Lead Address';
                break;

            default:
                console.warn(`Unsupported object type: ${objectType}`);
                return;
        }

        // Build request dynamically
        const objectRequest = ObjectRequestList.createComplexRequestList(
            true,
            ObjectRequestComplex.build(
                true,
                false,
                ObjectRequestComplexNode.createRelationNode(mainRelationName, ObjectRequestRelation.createJoin(`${addressRelationNode}`))),
            [FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            null
        );

        // Call API dynamically based on service type
        const service = this.coreService.getCrudService(objectType);


        if (!service) {
            console.error(`No service available for ${objectType}`);
            return;
        }

        service.list(objectRequest).subscribe(res => {
            const dto = res.entries[0];
            this.name = dto?.['calculatedName']; // works for both lead & customer
            this.addresses = dto?.['customerAddress'] || dto?.['leadAddress'] || [];

            // Select appropriate main or fallback address
            this.selectAddress = this.addresses[0]?.addressDtoId;
            this.addressId = this.selectAddress;

            const address = this.addresses.find(a => a.addressDtoId === this.addressId);
            this.addressName = address?.addressDtoName || '';

            // Prepare DtoList
            const formName = this.addresses === dto?.['customerAddress'] ? 'customerAddress' : 'leadAddress';
            const form = res.form.getSubForm(formName);
            const dtoList: DtoList = new DtoList();
            dtoList.form = form;
            dtoList.entries = this.addresses;

            // Build widget dynamically
            this.addressWidget = WidgetFactory.createWidgetTransient(
                addressWidgetKey,
                addressWidgetTitle,
                'list',
                'transient',
                'transient',
                addressEntity,
                dtoList);

            // Attach callbacks
            const fields: WidgetToolbarCreateInterface[] = [
                {
                    fieldName: objectType === 'cr.Customer' ? 'customerDtoId' : 'leadDtoId',
                    fieldValue: this.objectIdentifier.objectId
                }
            ];

            this.addressWidget.functionCallbacks =
                WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
        });
    }

    refreshAddressObjectWidget() {

        this.addressObjectWidget = WidgetFactory.createWidgetObject(
            'tm.ticket.customer.address.widget.object',
            'Address',
            'ad.Address',
            0
        );

    }


    showCustomerCallWidget() {

        let recipientType: CallRecipientTypeEnum;

        if (this.objectIdentifier.objectType == 'cr.Customer') {
            recipientType = CallRecipientTypeEnum.customer
        } else if (this.objectIdentifier.objectType == 'lm.LmLead') {
            recipientType = CallRecipientTypeEnum.lead
        }

        const filterCriteriaList = [];

        filterCriteriaList.push(
            FilterCriteria.create('e.objectId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId),
            FilterCriteria.create('e.callRecipientType', FilterCriteria.cOperatorEqual, recipientType)
        );

        const alias = 'tm.ticket.cr.customer.communication.navigation.show.customer.calls';

        const qlQueryDto: QlQueryDto = {
            name: alias,
            type: 'view',
            fixedFilters: filterCriteriaList,
            sortings: [new Sorting("e.startTime", false)],
            start: {
                name: "pc.Call",
                as: "e",
                type: "entity",
                joins: [
                    {
                        joinType: "left",
                        type: "entity",
                        name: "agent",
                        as: "a",
                        joins : [
                            {
                                joinType: "left",
                                type: "entity",
                                name: "user",
                                as: "u",
                            }
                        ]
                    },
                    {
                        joinType: "left",
                        type: "entity",
                        name: "callType",
                        as: "ct",
                    },
                    {
                        joinType: "left",
                        type: "entity",
                        name: "pc.CallProtocol#call",
                        as: "cp",
                    }
                ]
            }
        };

        this.objectCallsWidget = WidgetFactory.createWidgetListQl(
            alias,
            "Anrufe",
            "list",
            qlQueryDto
        )
    }

    handleAppointmentCreate(appointment: MsCalendarEventDto) {
        this.onAppointmentCreate.emit(appointment);
    }

    handleAddressCreation(objectChange: ObjectChangeInformation) {
        this.addressId = objectChange.after.id;
        this.addressName = objectChange.after.name;
        this.getMainAddress();
    }



    onTabChange(newValue: TabViewType | any) {
        this.activeIndex = newValue;
        this.currentView = newValue;

            if (this.currentView == 'address') {
                this.getMainAddress();
            }

            if (this.currentView == 'appointment') {
                this.fetchAppointmentTypeAgents();
            }

    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
